(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var CFG = window.THEME_CFG || {};
  var ROOT = CFG.root || '/';
  var JSON_H = { 'Content-Type': 'application/json', Accept: 'application/json' };

  /* ---------- helpers ---------- */
  function formatMoney(cents) {
    var f = CFG.moneyFormat || '{{amount_no_decimals}}';
    function num(v, d, t, dp) {
      d = d === undefined ? 2 : d; t = t === undefined ? ',' : t; dp = dp || '.';
      var s = (v / 100).toFixed(d).split('.');
      s[0] = s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t);
      return s.join(d ? dp : '');
    }
    var out = f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount_no_decimals': return num(cents, 0);
        case 'amount_with_comma_separator': return num(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(cents, 0, '.', ',');
        case 'amount_no_decimals_with_space_separator': return num(cents, 0, ' ');
        default: return num(cents, 2);
      }
    });
    return out.replace(/([.,])00(?!\d)/, '');
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function sized(u, w) { return u ? u.replace(/\.(jpg|jpeg|png|gif|webp)(\?|$)/i, '_' + w + 'x.$1$2') : ''; }
  function toast(msg, href, label) {
    var t = $('#Toast'); if (!t) return;
    t.innerHTML = '<span>' + esc(msg) + '</span>' + (href ? '<a href="' + href + '">' + esc(label || 'View') + '</a>' : '');
    t.classList.add('is-on');
    clearTimeout(toast._t); toast._t = setTimeout(function () { t.classList.remove('is-on'); }, 3000);
  }
  var cache = {};
  function getProduct(handle) {
    if (!cache[handle]) cache[handle] = fetch(ROOT + 'products/' + handle + '.js').then(function (r) { return r.json(); });
    return cache[handle];
  }
  function load(key) { try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) { return []; } }
  function save(key, val) { try { localStorage.setItem(key, JSON.stringify(val)); } catch (e) {} }

  /* ---------- layers ---------- */
  function open(el) { if (!el) return; el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); document.documentElement.classList.add('no-scroll'); document.dispatchEvent(new Event('layerchange')); }
  function close(el) {
    if (!el) return; el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
    if (!$('.overlay.is-open,.sheet.is-open,.modal.is-open')) document.documentElement.classList.remove('no-scroll');
    document.dispatchEvent(new Event('layerchange'));
  }
  function closeAll() { $$('.overlay.is-open,.sheet.is-open,.modal.is-open').forEach(close); }

  /* ---------- cart: instant UI, requests run in a queue ---------- */
  var queue = Promise.resolve();
  function enqueue(fn) { queue = queue.then(fn, fn); return queue; }
  function setCount(n) { $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; }); }
  function getCount() { return parseInt(($('[data-cart-count]') || {}).textContent || '0', 10) || 0; }
  function updateCount() {
    return fetch(ROOT + 'cart.js').then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); return c; });
  }
  function refreshCartPage() {
    var page = $('[data-cart-page]'); if (!page) return updateCount();
    return Promise.all([updateCount(), fetch(ROOT + 'cart?sections=main').then(function (r) { return r.json(); })]).then(function (res) {
      var doc = new DOMParser().parseFromString(res[1].main, 'text/html');
      var fresh = doc.querySelector('[data-cart-page]');
      if (fresh) page.innerHTML = fresh.innerHTML; else location.reload();
    }).catch(function () { location.reload(); });
  }
  function rawAdd(id, qty) {
    return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: JSON_H, body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] }) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Could not add to bag'); return d; }); });
  }
  function addInstant(id, qty) {
    var before = getCount();
    setCount(before + (qty || 1));
    toast('Added to bag', ROOT + 'cart', 'View bag');
    return enqueue(function () { return rawAdd(id, qty); })
      .then(function () { return updateCount(); })
      .catch(function (e) { setCount(before); toast(e.message); });
  }
  function buyNow(id) {
    return rawAdd(id, 1).then(function () { window.location.href = ROOT + 'checkout'; });
  }

  // cart page lines
  function recalc() {
    var lines = $$('.cart-line[data-key]:not(.is-removing)'), total = 0, count = 0;
    lines.forEach(function (li) { total += (+li.dataset.unit) * (+li.dataset.qty); count += +li.dataset.qty; });
    $$('[data-cart-total]').forEach(function (el) { el.textContent = formatMoney(total); });
    setCount(count);
    return lines.length;
  }
  function paintLine(li, qty) {
    li.dataset.qty = qty;
    var t = $('[data-qty-text]', li); if (t) t.textContent = qty;
    var p = $('[data-line-price]', li); if (p) p.textContent = formatMoney((+li.dataset.unit) * qty);
  }
  function lineChange(li, delta) {
    var qty = delta === 'remove' ? 0 : Math.max(0, (+li.dataset.qty) + parseInt(delta, 10));
    var key = li.dataset.key;
    if (qty === 0) { li.classList.add('is-removing'); setTimeout(function () { if (li.parentNode) li.parentNode.removeChild(li); }, 230); }
    else paintLine(li, qty);
    var left = recalc();
    if (!left) { var f = $('.cartpage__foot'); if (f) f.hidden = true; }
    enqueue(function () {
      return fetch(ROOT + 'cart/change.js', { method: 'POST', headers: JSON_H, body: JSON.stringify({ id: key, quantity: qty }) }).then(function (r) { return r.json(); });
    }).then(function (cart) {
      if (!cart || !cart.items) return refreshCartPage();
      if (cart.item_count === 0) return refreshCartPage();
      cart.items.forEach(function (it) {
        var el = $('.cart-line[data-key="' + it.key + '"]');
        if (el && (+el.dataset.qty) !== it.quantity) { paintLine(el, it.quantity); toast('Only ' + it.quantity + ' available'); }
      });
      $$('[data-cart-total]').forEach(function (el) { el.textContent = formatMoney(cart.total_price); });
      setCount(cart.item_count);
    }).catch(function () { refreshCartPage(); });
  }

  /* ---------- variant picker ---------- */
  function buildPicker(host, p, onChange) {
    var names = p.options.map(function (o) { return typeof o === 'string' ? o : o.name; });
    var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
    var sel = first.options ? first.options.slice() : [first.option1, first.option2, first.option3].filter(Boolean);
    function current() { return p.variants.filter(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); })[0] || null; }
    function render() {
      host.innerHTML = '';
      names.forEach(function (name, i) {
        var vals = []; p.variants.forEach(function (v) { if (vals.indexOf(v.options[i]) < 0) vals.push(v.options[i]); });
        if (p.variants.length === 1 && vals[0] === 'Default Title') return;
        var g = document.createElement('div'); g.className = 'picker__group';
        if (names.length > 1) { var l = document.createElement('p'); l.className = 'picker__label'; l.textContent = name; g.appendChild(l); }
        var w = document.createElement('div'); w.className = 'pills';
        vals.forEach(function (val) {
          var b = document.createElement('button'); b.type = 'button'; b.className = 'pill' + (sel[i] === val ? ' is-on' : ''); b.textContent = val;
          b.disabled = !p.variants.some(function (v) { return v.options[i] === val && v.available; });
          b.addEventListener('click', function () {
            sel[i] = val;
            if (!current()) {
              var m = p.variants.filter(function (v) { return v.options[i] === val && v.available; })[0] || p.variants.filter(function (v) { return v.options[i] === val; })[0];
              if (m) sel = m.options.slice();
            }
            render(); onChange(current());
          });
          w.appendChild(b);
        });
        g.appendChild(w); host.appendChild(g);
      });
    }
    render(); onChange(current());
    return { get: current };
  }

  /* ---------- quick add ---------- */
  var qa = { variant: null };
  function quickAdd(handle) {
    getProduct(handle).then(function (p) {
      if (p.variants.length === 1) {
        if (!p.variants[0].available) return toast('Sold out');
        return addInstant(p.variants[0].id, 1);
      }
      var sheet = $('#QuickAdd');
      $('[data-qa-title]', sheet).textContent = p.title;
      $('[data-qa-sizeguide]', sheet).href = p.url;
      var priceEl = $('[data-qa-price]', sheet);
      buildPicker($('[data-qa-picker]', sheet), p, function (v) {
        qa.variant = v;
        priceEl.textContent = v ? formatMoney(v.price) : '';
        var ok = v && v.available;
        $$('[data-qa-add],[data-qa-buy]', sheet).forEach(function (b) { b.disabled = !ok; });
      });
      open(sheet);
    });
  }

  /* ---------- saved items (instant, no network) ---------- */
  var WL = 'urbanri_saved_v2';
  function savedList() {
    return load(WL).filter(function (x) { return x && typeof x === 'object' && x.h; });
  }
  function paintWl() {
    var a = savedList().map(function (x) { return x.h; });
    $$('[data-wishlist]').forEach(function (b) { b.classList.toggle('is-on', a.indexOf(b.dataset.wishlist) > -1); });
    $$('[data-wl-count]').forEach(function (el) { el.textContent = a.length; el.hidden = !a.length; });
  }
  function toggleWl(btn) {
    var h = btn.dataset.wishlist, a = savedList(), i = -1;
    a.forEach(function (x, n) { if (x.h === h) i = n; });
    if (i > -1) a.splice(i, 1);
    else a.unshift({ h: h, t: btn.dataset.title || h, u: btn.dataset.url || (ROOT + 'products/' + h), i: btn.dataset.image || '', p: +btn.dataset.price || 0 });
    save(WL, a); paintWl();
    if ($('#WishOverlay.is-open')) renderWishlist();
  }
  function miniCard(x) {
    var bm = ($('#tpl-bookmark') || {}).innerHTML || '';
    var img = x.i ? '<img loading="lazy" src="' + esc(x.i) + '" alt="' + esc(x.t) + '">' : '';
    return '<article class="card"><div class="card__media"><div class="card__track"><a class="card__slide" href="' + esc(x.u) + '">' + img + '</a></div>' +
      '<button type="button" class="bookmark is-on" data-wishlist="' + esc(x.h) + '" data-title="' + esc(x.t) + '" data-url="' + esc(x.u) + '" data-image="' + esc(x.i) + '" data-price="' + (x.p || 0) + '" aria-label="Remove from saved">' + bm + '</button></div>' +
      '<div class="card__meta"><div><a class="card__title" href="' + esc(x.u) + '">' + esc(x.t) + '</a><p class="card__price">' + formatMoney(x.p || 0) + '</p></div></div></article>';
  }
  function renderWishlist() {
    var grid = $('[data-wishlist-grid]'), empty = $('[data-wishlist-empty]'), a = savedList();
    grid.innerHTML = a.map(miniCard).join('');
    if (empty) empty.hidden = a.length > 0;
  }

  /* ---------- recently viewed ---------- */
  var RV = 'urbanri_recent_v2';
  function trackViewed() {
    var pdp = $('[data-pdp]'); if (!pdp) return;
    var h = pdp.dataset.handle, a = load(RV).filter(function (x) { return x && x.h && x.h !== h; });
    a.unshift({ h: h, t: pdp.dataset.title, u: pdp.dataset.url, i: pdp.dataset.image, p: +pdp.dataset.price || 0 });
    save(RV, a.slice(0, 10));
  }
  function renderRecent() {
    var sec = $('[data-recently-viewed]'); if (!sec) return;
    var ex = sec.dataset.exclude, list = load(RV).filter(function (x) { return x && x.h && x.h !== ex; }).slice(0, 4);
    if (!list.length) return;
    $('[data-rv-grid]', sec).innerHTML = list.map(miniCard).join('');
    sec.hidden = false; paintWl();
  }

  /* ---------- newest / best-seller feeds ---------- */
  function initFeeds() {
    $$('[data-feed]').forEach(function (sec) {
      var kind = sec.dataset.feed, n = parseInt(sec.dataset.limit, 10) || 4, grid = $('[data-feed-grid]', sec);
      var sort = kind === 'newest' ? 'created-descending' : 'best-selling';
      fetch(ROOT + 'collections/all?view=rail&sort_by=' + sort)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var cards = $$('.card', doc).slice(0, n);
          if (!cards.length) return;
          grid.innerHTML = '';
          cards.forEach(function (c) { grid.appendChild(document.importNode(c, true)); });
          paintWl();
        }).catch(function () {});
    });
  }

  /* ---------- product page ---------- */
  function initPdp() {
    var pdp = $('[data-pdp]'); if (!pdp) return;
    var priceEl = $('[data-pdp-price]', pdp), add = $('[data-pdp-add]', pdp), buy = $('[data-pdp-buy]', pdp), state = { variant: null };
    getProduct(pdp.dataset.handle).then(function (p) {
      buildPicker($('[data-pdp-picker]', pdp), p, function (v) {
        state.variant = v;
        if (v) {
          priceEl.innerHTML = (v.compare_at_price > v.price ? '<s>' + formatMoney(v.compare_at_price) + '</s> ' : '') + formatMoney(v.price);
          try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
        }
        var ok = v && v.available;
        add.disabled = buy.disabled = !ok; add.textContent = ok ? 'Add to bag' : 'Sold out';
      });
    });
    add.addEventListener('click', function () { if (state.variant) addInstant(state.variant.id, 1); });
    buy.addEventListener('click', function () { if (state.variant) buyNow(state.variant.id).catch(function (e) { toast(e.message); }); });
    var track = $('[data-gallery]', pdp), idxEl = $('[data-gallery-index]', pdp);
    if (track && idxEl) track.addEventListener('scroll', function () { idxEl.textContent = Math.round(track.scrollLeft / track.clientWidth) + 1; }, { passive: true });
  }

  /* ---------- predictive search ---------- */
  function initSearch() {
    var input = $('[data-search-input]'), res = $('[data-search-results]'), def = $('[data-search-default]'), t;
    if (!input) return;
    input.addEventListener('input', function () {
      clearTimeout(t); var q = input.value.trim();
      if (q.length < 2) { res.innerHTML = ''; def.hidden = false; return; }
      t = setTimeout(function () {
        fetch(ROOT + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8')
          .then(function (r) { return r.json(); }).then(function (j) {
            var items = (j.resources && j.resources.results && j.resources.results.products) || [];
            def.hidden = true;
            res.innerHTML = items.length ? items.map(function (p) {
              return '<a href="' + p.url + '">' + (p.image ? '<img src="' + sized(p.image, 160) + '" alt="">' : '') + '<span><strong>' + esc(p.title) + '</strong><br><span class="muted">' + formatMoney(parseFloat(p.price) * 100) + '</span></span></a>';
            }).join('') : '<p class="muted">No results. Try another word.</p>';
          }).catch(function () {});
      }, 220);
    });
  }

  /* ---------- reveal + orders page ---------- */
  function initReveal() {
    var els = $$('.reveal'); if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }
  function countUp(el, to) {
    if (!to) { el.textContent = 0; return; }
    var start = null, dur = 900;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      el.textContent = Math.round(to * (1 - Math.pow(1 - p, 3)));
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function initOrders() {
    var wrap = $('[data-orders]'); if (!wrap) return;
    var cards = $$('.order-card', wrap);
    var stats = { all: cards.length, present: 0, delivered: 0, cancelled: 0 };
    cards.forEach(function (c) { if (c.dataset.group === 'present') stats.present++; if (c.dataset.status === 'delivered') stats.delivered++; if (c.dataset.status === 'cancelled') stats.cancelled++; });
    $$('[data-stat]').forEach(function (el) { countUp(el, stats[el.dataset.stat] || 0); });
    var st = { group: 'all', status: 'all', sort: 'new' };
    function apply() {
      var list = $('[data-order-list]', wrap), n = 0;
      cards.slice().sort(function (a, b) { var d = (+a.dataset.ts) - (+b.dataset.ts); return st.sort === 'new' ? -d : d; })
        .forEach(function (c) { list.appendChild(c); });
      cards.forEach(function (c) {
        var ok = (st.group === 'all' || c.dataset.group === st.group) && (st.status === 'all' || c.dataset.status === st.status);
        c.hidden = !ok; if (ok) { c.classList.add('is-in'); n++; }
      });
      $('[data-order-empty]', wrap).hidden = n > 0;
    }
    wrap.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ofilter]');
      if (b) {
        var k = b.dataset.ofilter; st[k] = b.dataset.value;
        $$('[data-ofilter="' + k + '"]', wrap).forEach(function (x) { x.classList.toggle('is-on', x === b); });
        return apply();
      }
      var tg = e.target.closest('[data-order-toggle]');
      if (tg) {
        var card = tg.closest('.order-card'), isOpen = card.classList.toggle('is-open');
        tg.setAttribute('aria-expanded', isOpen);
      }
    });
    $('[data-osort]', wrap).addEventListener('change', function (e) { st.sort = e.target.value; apply(); });
    apply();
  }


  /* ---------- desktop header: transparent over banner, collections cards + 3-lines menu panel ---------- */
  function initHeader() {
    var hdr = $('.hdr'); if (!hdr) return;
    var mega = $('#Mega'), megaBtn = $('[data-mega-toggle]'), mm = $('#MenuPanel'), mmBtn = $('[data-menu-toggle]'), t;
    var hoverOk = window.matchMedia && window.matchMedia('(hover:hover)').matches;
    function anyOpen() { return !!((mega && mega.classList.contains('is-open')) || (mm && mm.classList.contains('is-open')) || $('#SearchOverlay.is-open')); }
    function solid() { hdr.classList.toggle('is-solid', window.scrollY > 10 || anyOpen()); }
    function setMega(on) {
      if (!mega) return;
      if (on && mm) setMenu(false);
      mega.classList.toggle('is-open', on); mega.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (megaBtn) megaBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
      solid();
    }
    function setMenu(on) {
      if (!mm) return;
      if (on && mega) setMega(false);
      mm.classList.toggle('is-open', on); mm.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (mmBtn) mmBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
      solid();
    }
    window.addEventListener('scroll', solid, { passive: true }); document.addEventListener('layerchange', solid); solid();
    if (megaBtn && mega) {
      megaBtn.addEventListener('click', function (e) { e.stopPropagation(); setMega(hoverOk ? true : !mega.classList.contains('is-open')); });
      if (hoverOk) {
        megaBtn.addEventListener('mouseenter', function () { clearTimeout(t); setMega(true); });
        megaBtn.addEventListener('mouseleave', function () { t = setTimeout(function () { setMega(false); }, 220); });
        mega.addEventListener('mouseenter', function () { clearTimeout(t); });
        mega.addEventListener('mouseleave', function () { t = setTimeout(function () { setMega(false); }, 220); });
      }
    }
    if (mmBtn && mm) {
      mmBtn.addEventListener('click', function (e) { e.stopPropagation(); setMenu(!mm.classList.contains('is-open')); });
      $('[data-menu-close]', mm).addEventListener('click', function () { setMenu(false); });
    }
    document.addEventListener('click', function (e) {
      if (mega && mega.classList.contains('is-open') && !e.target.closest('#Mega') && !e.target.closest('[data-mega-toggle]')) setMega(false);
      if (mm && mm.classList.contains('is-open') && !e.target.closest('.mm__panel') && !e.target.closest('[data-menu-toggle]')) setMenu(false);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { setMega(false); setMenu(false); } });
  }

  /* ---------- welcome popup ---------- */
  function initWelcome() {
    var w = $('#Welcome'); if (!w) return;
    var seen = false; try { seen = sessionStorage.getItem('urbanri_welcome') === '1'; } catch (e) {}
    if (seen) return;
    function hide() { w.classList.remove('is-on'); setTimeout(function () { w.hidden = true; }, 450); try { sessionStorage.setItem('urbanri_welcome', '1'); } catch (e) {} }
    setTimeout(function () { w.hidden = false; requestAnimationFrame(function () { w.classList.add('is-on'); }); setTimeout(hide, 9000); }, 1400);
    $('[data-welcome-close]', w).addEventListener('click', hide);
  }

  /* ---------- global events ---------- */
  document.addEventListener('click', function (e) {
    var t;
    if (e.target.id === 'SearchOverlay' && window.innerWidth >= 900) { close(e.target); return; }
    var openMenu = $('#MenuOverlay.is-open');
    if (openMenu && !e.target.closest('#MenuOverlay') && !e.target.closest('[data-open-menu]')) close(openMenu);
    if (e.target.closest('[data-open-menu]')) { e.preventDefault(); return open($('#MenuOverlay')); }
    if (e.target.closest('[data-open-wishlist]')) { e.preventDefault(); renderWishlist(); return open($('#WishOverlay')); }
    if ((t = e.target.closest('[data-history-back]'))) {
      e.preventDefault();
      if (document.referrer && document.referrer.indexOf(location.host) > -1 && history.length > 1) history.back(); else location.href = t.dataset.fallback || ROOT;
      return;
    }
    if (e.target.closest('[data-open-search]')) { e.preventDefault(); open($('#SearchOverlay')); var i = $('[data-search-input]'); if (i) setTimeout(function () { i.focus(); }, 280); return; }
    if (e.target.closest('[data-close-overlay]')) return close(e.target.closest('.overlay'));
    if ((t = e.target.closest('[data-card-arrow]'))) {
      e.preventDefault(); var tr = $('[data-card-track]', t.parentElement);
      if (tr) tr.scrollBy({ left: tr.clientWidth * parseInt(t.dataset.cardArrow, 10), behavior: 'smooth' });
      return;
    }
    if ((t = e.target.closest('[data-quick-add]'))) { e.preventDefault(); return quickAdd(t.dataset.quickAdd); }
    if (e.target.closest('[data-qa-close]')) return close($('#QuickAdd'));
    if (e.target.closest('[data-qa-add]')) { if (!qa.variant) return; var v = qa.variant; close($('#QuickAdd')); return addInstant(v.id, 1); }
    if (e.target.closest('[data-qa-buy]')) { if (qa.variant) buyNow(qa.variant.id).catch(function (er) { toast(er.message); }); return; }
    if ((t = e.target.closest('[data-wishlist]'))) { e.preventDefault(); return toggleWl(t); }
    if ((t = e.target.closest('[data-line-action]'))) { var li = t.closest('.cart-line'); if (li) lineChange(li, t.dataset.delta); return; }
    if ((t = e.target.closest('[data-tab]'))) {
      var wrap = t.closest('[data-tabs]');
      $$('[data-tab]', wrap).forEach(function (b) { b.classList.toggle('is-on', b === t); });
      $$('[data-tabpanel]', wrap).forEach(function (p) { p.classList.toggle('is-on', p.dataset.tabpanel === t.dataset.tab); });
      return;
    }
    if ((t = e.target.closest('[data-open-modal]'))) return open(document.getElementById(t.dataset.openModal));
    if (e.target.closest('[data-close-modal]')) return close(e.target.closest('.modal'));
    if (e.target.closest('[data-open-filters]')) return open($('#Filters'));
    if (e.target.closest('[data-close-filters]')) return close($('#Filters'));
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-card-track]')) {
      var i = Math.round(t.scrollLeft / t.clientWidth);
      $$('.card__dots i', t.parentElement).forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
    }
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    paintWl(); initHeader(); initWelcome(); initPdp(); initSearch(); trackViewed(); renderRecent(); initFeeds(); initReveal(); initOrders();
    var form = $('#FilterForm');
    if (form) form.addEventListener('submit', function () { $$('input[type=number]', form).forEach(function (i) { if (!i.value) i.disabled = true; }); });
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) { paintWl(); updateCount(); } });
})();
